import ValidatorHelper from 'viralstyle-ui/src/ValidatorHelper';

export const validator = new ValidatorHelper({
  domain: {
    rules: 'required|domain',
    prettty: 'domain',
  },
  company_name: {
    rules: 'required|min:3|max:50',
    pretty: 'company name',
  },
  about: {
    rules: 'max:1000',
    pretty: 'page description',
  },
  'meta.ga_code': {
    rules: 'ga',
    pretty: 'google analytics code',
  },
  'meta.fb_pixel_id': {
    rules: 'numeric|max:20',
    pretty: 'facebook pixel id',
  },
  'meta.google_verification': {
    rules: 'max:50',
    pretty: 'google site verification'
  },
  'meta.fb_domain_verification': {
    rules: 'max:50',
    pretty: 'facebook domain verification',
  },
  'styles.brand_color': {
    rules: 'required|hex',
    pretty: 'brand color',
  },
  'styles.bg_color': {
    rules: 'required|hex',
    pretty: 'background color',
  },
  'styles.text_color': {
    rules: 'required|hex',
    pretty: 'text color',
  },
  'styles.links.text_color': {
    rules: 'required|hex',
    pretty: 'link text color',
  },
  'styles.header.bg_color': {
    rules: 'required|hex',
    pretty: 'header background color',
  },
  'styles.header.border_color': {
    rules: 'required|hex',
    pretty: 'header border color',
  },
  'styles.inputs.bg_color': {
    rules: 'required|hex',
    pretty: 'input background color',
  },
  'styles.inputs.border_color': {
    rules: 'required|hex',
    pretty: 'input border color',
  },
  'styles.inputs.text_color': {
    rules: 'required|hex',
    pretty: 'input text color',
  },
  'styles.inputs.label_color': {
    rules: 'required|hex',
    pretty: 'input label color',
  },
  'styles.inputs.border_radius': {
    rules: 'numeric',
    pretty: 'input border radius',
  },
});